<template>
  <div>
    <div>
      <a-table class="ant-table-striped" :columns="columns" :data-source="data" :rowClassName="rowClassName" bordered rowKey="id">
        <template #operation="{ record }">
          <div class="flex_sa">
            <div class="editable-row-operations flex_sa">
              <span>
                <a @click="edit(record)">管理集团品牌介绍</a>
              </span>
            </div>
          </div>

        </template>

        <template v-for="col in ['groupName']" #[col]="{ text, record }" :key="col">
          <div>
            {{ record.group.name }}
          </div>
        </template>
        <template v-for="col in ['recommendIndex']" #[col]="{ text, record }" :key="col">
          <div>
            {{ record.appSetting?.recommendIndex }}
          </div>
        </template>

      </a-table>

    </div>

  </div>
  <brandIntroduction v-model="visible" :record="record" />

</template>


<style scoped>
.online {
  background: #40a9ff;
  border-color: #40a9ff;
}

.offline {
  background: #979596;
  border-color: #979596;
}

:deep(.ant-table-tbody > tr > td, .ant-table-thead > tr > th) {
  padding: 10px 8px;
}

.table_btn {
  width: 70px;
  display: inline-block;
  text-align: center;
}

.clickable {
  /* background-color: #000; */
  width: 100%;
  height: 100%;
}
</style>


<script>
import {
  SearchOutlined,
  PlusOutlined,
  DownloadOutlined,
  CheckCircleFilled,
  WarningFilled,
  FormOutlined
} from "@ant-design/icons-vue";
import { reactive } from "vue";
import { cloneDeep } from "lodash-es";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { Search } from "/src/api/linkEnterprise.js";
import { pinyin } from 'pinyin-pro';
import brandIntroduction from '/src/components/common/brandIntroduction.vue';

export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    DownloadOutlined,
    locale,
    CheckCircleFilled,
    WarningFilled,
    FormOutlined,
    brandIntroduction
  },
  name: "医生管理",
  data() {
    return {
      modalBtn: "",
      modalIndex: "0",
      clubId: undefined,
      visible: false,
      active: undefined,
      id: undefined,
      selectedRow: {},
      total: 0,
      current: 1,
      // pageSize: 10,
      inputs: {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
      },
      modelInput: {
        name: undefined,
        gender: undefined,
        nameInitial: undefined,
        isStandard: true,
      },
      clubList: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      option: [{ value: "黄浦区" }, { value: "浦东新区" }, { value: "长宁区" }],
      columns: [
        {
          title: "编号",
          key: "id",
          dataIndex: "id",
          width: "15%",
          slots: {
            customRender: "id"
          }
        },
        {
          title: "名称",
          key: "name",
          dataIndex: "name",
          ellipsis: true,
          width: "15%",
          slots: {
            customRender: "name"
          },
        },
        {
          title: "地址",
          width: "15%",
          key: "address",
          dataIndex: "address",
          slots: {
            customRender: "address"
          }
        },
        {
          title: "电话",
          key: "telephone",
          dataIndex: "telephone",
          // ellipsis: true,
          width: "15%",
          slots: {
            customRender: "telephone"
          }
        },
        {
          title: "所属集团",
          key: "groupName",
          dataIndex: "groupName",
          width: "15%",
          slots: {
            customRender: "groupName"
          }
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "15%",
          slots: {
            customRender: "operation"
          }
        }
      ],
      data: [],

      // doExcel: doExcel
    };
  },
  created() { },
  mounted() {
    this.init();
  },
  activated() {
    if (localStorage.getItem("refrashProject") == "true") {
      // this.search(1);
    }
    localStorage.setItem("refrashProject", false);
  },
  methods: {
    init() {
      this.search("")
    },

    async getClubList() {
      let res = await ClubList({ clubCategory: "门诊部", checked: true })
      console.log(res.data);

      if (res.errCode == 0) {
        this.clubList = res.data
      }
    },
    closeModal(value) {
      this[value] = false;
    },

    resetForm() {
      this.inputs = {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
      }
    },

    async onDelete(id) {
      this.editableData = {}
      let res = await Delete({ id })
      this.data = this.data.filter(function (item) {
        return item.id !== id;
      });
    },
    edit(record) {
      this.visible = true;
      this.record = { ...record ,objectCategory: '集团',category:'品牌介绍' };
    },
    async save(id) {
      let _data = this.data;
      //判断editableData和修改前是否一致，如果一致则不修改
      if (JSON.stringify(this.data.find((item) => item.id == id)) === JSON.stringify(this.editableData[id])) {
        delete this.editableData[id];
        return;
      }
      let params = {
        id: this.editableData[id].id,
        name: this.editableData[id].name,
        nameInitial: this.editableData[id].nameInitial,
        gender: this.editableData[id].gender,
      }
      console.log(params);
      let res = await Update(params)
      if (res.errCode == 0) {
        Object.assign(
          _data.filter(item => id === item.id)[0],
          this.editableData[id]
        );
        delete this.editableData[id];
      }
    },
    cancel(id) {
      delete this.editableData[id];
    },
    tabsName(tabName) {
      this.$store.commit("changePage", { name: tabName.name, query: tabName.query });
    },
    async search(pagination) {

      let _this = this;
      // this.currentClientAppName = this.inputs.clientAppName
      let params = {
        includeGroup: true
      };

      let res = await Search(params)
      console.log(res);

      if (res.errCode == 0) {

        this.data = res.data
        // this.$message.success("查询成功", function () { });

      } else {
        this.$message.error("查询失败", function () { });
      }
      // this.data = res
    },


  }
};
</script>